import clsx from "clsx";

import { LearnerFileType } from "@api/graphql/types-and-hooks";
import { ZoomControls } from "@components/DocumentReviewModal/components/ZoomControls";
import { useZoomAndPan } from "@components/DocumentReviewModal/hooks/useZoomAndPan";

interface DocumentViewerImageProps {
  file: LearnerFileType;
}

export const DocumentViewerImage: React.FC<DocumentViewerImageProps> = ({ file }) => {
  const { scale, isDragging, scrollRef, zoomIn, zoomOut, onMouseDown, onMouseMove, onMouseUp } = useZoomAndPan(
    file.signedS3LearnerFile,
  );

  if (!file.signedS3LearnerFile) {
    return (
      <div className="flex items-center justify-center h-full">
        <p>File is not available</p>
      </div>
    );
  }

  return (
    <div className="relative flex flex-col h-full">
      <div
        ref={scrollRef}
        className={clsx("overflow-auto flex-1 select-none", isDragging ? "cursor-grabbing" : "cursor-grab")}
        onMouseDown={onMouseDown}
        onMouseMove={onMouseMove}
        onMouseUp={onMouseUp}
        onMouseLeave={onMouseUp}
      >
        <img
          src={file.signedS3LearnerFile}
          alt="Document preview"
          style={{ width: `${scale * 100}%` }}
          className="max-w-none flex m-auto"
        />
      </div>

      <ZoomControls scale={scale} onZoomIn={zoomIn} onZoomOut={zoomOut} />
    </div>
  );
};
